<template>
  <div class>
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>Mon profil</v-toolbar-title>
    </v-toolbar>
    <v-container fluid>
      <v-row>
        <v-col cols="6" md="12" lg="6">
          <v-card elevation="0">
            <v-card-title>Informations personnelles</v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item>
                  <v-list-item-content>E-mail:</v-list-item-content>
                  <v-list-item-content class="subtitle-1 align-end">{{ user.email }}</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Phone:</v-list-item-content>
                  <v-list-item-content class="subtitle-1 align-end">{{ user.phone }}</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Compte:</v-list-item-content>
                  <v-list-item-content
                    class="subtitle-1 align-end"
                    v-if="user.account"
                  >{{ user.account.name }}</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Role:</v-list-item-content>
                  <v-list-item-content class="subtitle-1 align-end">{{ user.role }}</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Group:</v-list-item-content>
                  <v-list-item-content
                    class="subtitle-1 align-end"
                    v-if="user.account"
                  >{{ user.group.name }}</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <change-password />
              <v-spacer></v-spacer>
              <update-profile />
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="6" md="12" lg="6">
          <v-card elevation="0">
            <v-card-title>Crédits</v-card-title>
            <v-card-text>
              <h3>Votre solde</h3>
              <p class="orange--text text--darken-3 title">{{$format.money(user.funds)}}</p>
            </v-card-text>
            <v-card-actions>
              <add-funds v-if="canBuyCredit" @addFunds="check_auth()"></add-funds>
              <money-request v-else />
              <asked-money-request />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="user.role=='owner' || user.role=='manager'">
        <group-detail :groupId="user.group_id" @reload="check_auth()" />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AskedMoneyRequest from "../../components/profile/AskedMoneyRequest";
import AddFunds from "../../components/profile/AddFunds";
import UpdateProfile from "../../components/profile/UpdateProfile";
import ChangePassword from "../../components/profile/ChangePassword";
import GroupDetail from "../../components/profile/GroupDetail";
import MoneyRequest from "../../components/profile/MoneyRequest";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    AddFunds,
    UpdateProfile,
    ChangePassword,
    GroupDetail,
    MoneyRequest,
    AskedMoneyRequest
  },
  data: function() {
    return {};
  },
  computed: {
    ...mapState("auth", {
      user: state => state.user
    }),
    canBuyCredit() {
      if (
        this.user.role == "owner" ||
        (this.user.role == "manager" && this.user.group.canBuyCredit == "yes")
      )
        return true;
      return false;
    }
  },
  mounted: function() {},
  methods: {
    ...mapActions("auth", ["check_auth"]),
    buyCredit() {}
  }
};
</script>

<style>
</style>